import { ReactComponent as LoginLogo } from "../../../assets/logos/pbxscribe-logo.svg";
// --- Reusable Layout Component for the authentication screens---
export const AuthLayout = ({ title, subtitle, children, illustration, headerContent }) => {
  return (
    <div className="flex min-h-screen w-full overflow-y-auto">
      {/* LEFT SIDE: Form Area */}
      <div className="w-full lg:w-1/2 bg-white flex flex-col justify-center relative">
        {/* Logo Area */}
        <div className="absolute top-8 left-6 sm:left-12 lg:left-16">
          <LoginLogo className="h-10 sm:h-14 w-fit"/>
        </div>

        <div className={`max-w-xl w-full xl:px-0 p-5 sm:px-10 mx-auto my-10 ${title === "Sign Up" ? "mt-16" : ""}`}>
          {headerContent}
          <h1 className="text-2xl sm:text-3xl font-bold text-primary mb-4">{title}</h1>
          <p className="text-content mb-10 text-sm sm:text-base">{subtitle}</p>
          {children}
        </div>
      </div>

      {/* RIGHT SIDE: Illustration Area (Dark Blue) */}
      <div className="hidden lg:flex w-1/2 bg-primary items-center justify-center relative overflow-hidden">
        <div className="relative z-10 p-12">
          <img src={illustration} alt="Illustration" />
        </div>
      </div>
    </div>
  );
};
